module.exports = __webpack_public_path__ + "static/img/stage-1.768b559a.png";